import React, { useRef, useLayoutEffect } from 'react';
import { CModalFooter } from '@coreui/react';
import { useModalScrollProgress } from '../../hooks/useModalScrollProgress';
import WizardScrollableModalBody from './WizardScrollableModalBody';
import WizardModalScrollFooter from './WizardModalScrollFooter';
import { ErrorText } from '../utils/AvatarCropper';
import { Palette } from '../utils';
import {
  SCROLL_FOOTER_CHROME_MARGIN_PX,
  SCROLL_PROGRESS_TRACK_HEIGHT_PX
} from './modalScrollProgressStyles';

const WizardModalLayout = ({
  Modal,
  modalProps = {},
  show,
  onClose,
  width = '520px',
  children,
  footerActions,
  footerLayout = 'row',
  footerStyle,
  bodyGap = '16px',
  closeOnBackdrop = false,
  deps = [],
  error
}) => {
  const scrollRef = useRef(null);
  const scroll = useModalScrollProgress(scrollRef, deps);

  useLayoutEffect(() => {
    if (show && scrollRef.current) {
      scrollRef.current.scrollTop = 0;
      scroll.remeasure();
    }
  }, [show, ...deps]);

  return (
    <Modal
      show={show}
      onClose={onClose}
      width={width}
      closeOnBackdrop={closeOnBackdrop}
      {...modalProps}>
      <WizardScrollableModalBody bodyRef={scroll.bodyRef} scroll={scroll} gap={bodyGap}>
        {children}
      </WizardScrollableModalBody>

      <CModalFooter
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'stretch',
          gap: 8,
          flexShrink: 0,
          borderTop: 'none',
          marginTop: 0,
          padding: 0,
          paddingTop: SCROLL_FOOTER_CHROME_MARGIN_PX - SCROLL_PROGRESS_TRACK_HEIGHT_PX,
          background: Palette.WHITE,
          position: 'relative',
          zIndex: 1,
          ...(footerStyle || {})
        }}>
        {error && <ErrorText>{typeof error === 'string' ? error : error.message}</ErrorText>}
        <WizardModalScrollFooter footerLayout={footerLayout}>{footerActions}</WizardModalScrollFooter>
      </CModalFooter>
    </Modal>
  );
};

export default WizardModalLayout;
